import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { OrganisationTreeDto } from '@/api';
import { RequiredNotNull } from '@/api/models';

interface InitialState {
  id?: string;
  name?: string;
}

const initialState: InitialState = {
  id: undefined,
  name: undefined,
};

const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {
    setOrganisation: (state, { payload }: PayloadAction<RequiredNotNull<OrganisationTreeDto>>) => {
      state.id = payload.id;
      state.name = payload.name;
    },
  },
});

const { setOrganisation } = organisationSlice.actions;

const { name: organisationReducerName, reducer: organisationReducer } = organisationSlice;

export { organisationReducer, organisationReducerName, setOrganisation };
